"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeClick = exports.unhighlight = exports.highlight = exports.setBulkVisible = exports.setTextScale = exports.setTextOffset = exports.moveTo = exports.update = exports.updateAll = exports.killBulk = exports.kill = exports.setOnMouseOut = exports.setOnMouseOver = exports.setOnClick = exports.setVisible = exports.setTextTint = exports.setText = exports.setSelected = exports.setScale = exports.setAdditionalHighlightAndSelectedImages = exports.setIcon = exports.setTag = exports.setLocked = exports.create = exports.setDefaultFrames = exports.setDefaultFont = exports.defaultFramesMowerSm = exports.defaultFramesLite = exports.defaultFramesBasic = void 0;
var phaserUtil_sidecar_1 = require("../engine/phaserUtil-sidecar");
var pubSub_sidecar_1 = require("../engine/pubSub-sidecar");
var entitiesUtils_sidecar_1 = require("../entities/entitiesUtils-sidecar");
var imports_1 = require("../lib/imports");
var common_sidecar_1 = require("../main/common-sidecar");
var echoFonts_sidecar_1 = require("../proto/echo/echoFonts-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var clickEater_sidecar_1 = require("./clickEater-sidecar");
var stevieTexts2_sidecar_1 = require("./stevieTexts2-sidecar");
var objs = [];
var w = 50;
var h = 10;
// export const defaultFramesEcho: ISPD[] = sprites.echoButton
exports.defaultFramesBasic = sprites_sidecar_1.sprites.voyTileChecker1; // sprites.underButtonBasic
exports.defaultFramesLite = sprites_sidecar_1.sprites.voyTileChecker1; // sprites.underButtonLite
exports.defaultFramesMowerSm = sprites_sidecar_1.sprites.voyTileChecker1; //sprites.buttonMowerSm
var defaultFont = echoFonts_sidecar_1.echoFonts.getData().font4;
var setDefaultFont = function (font) {
    defaultFont = font;
};
exports.setDefaultFont = setDefaultFont;
var defaultFrames = exports.defaultFramesBasic;
var setDefaultFrames = function (frames) {
    defaultFrames = frames;
};
exports.setDefaultFrames = setDefaultFrames;
function create(layer, x, y, text, onClick, frames) {
    if (frames === void 0) { frames = defaultFrames; }
    var imageBackground = spritesUtil_sidecar_1.spritesUtil.createImage(layer, frames[0] || defaultFrames[0]);
    var imageAdditional = spritesUtil_sidecar_1.spritesUtil.createImage(layer, defaultFrames[0]);
    imageAdditional.visible = false;
    var imageIcon = null;
    var _text = stevieTexts2_sidecar_1.stevieTexts2.create(defaultFont, 0, 0, layer);
    stevieTexts2_sidecar_1.stevieTexts2.setText(_text, text);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(_text, 4);
    var obj = {
        eType: 'button',
        x: 0,
        y: 0,
        textOx: 0,
        textOy: 0,
        id: common_sidecar_1.common.createId(),
        idLoaded: 0,
        imageBackground: imageBackground,
        imageAdditional: imageAdditional,
        imageIcon: imageIcon,
        isMouseDown: false,
        isMouseRightDown: false,
        isOver: false,
        text: _text,
        frames: frames,
        frames2: [],
        onClick: onClick,
        onMouseOver: null,
        onMouseOut: null,
        isDead: false,
        isSelected: false,
        scale: 1,
        iconOx: -68,
        iconOy: 4,
        tag: '',
    };
    moveTo(obj, x, y);
    objs.push(obj);
    phaserUtil_sidecar_1.phaserUtil.setInteractive(imageBackground);
    imageBackground.on('pointerover', function () {
        obj.isOver = true;
        if (obj.onMouseOver) {
            obj.onMouseOver();
        }
    });
    imageBackground.on('pointerout', function () {
        obj.isOver = false;
        obj.isMouseDown = false;
        if (obj.onMouseOut) {
            obj.onMouseOut();
        }
    });
    imageBackground.on('pointerdown', function () {
        clickEater_sidecar_1.clickEater.tempEat();
        var scene = common_sidecar_1.common.getPhaserScene();
        if (scene.game.input.activePointer.rightButtonDown()) {
            obj.isMouseRightDown = true;
        }
        else {
            obj.isMouseDown = true;
        }
    });
    imageBackground.on('pointerup', function () {
        clickEater_sidecar_1.clickEater.tempEat();
        if (obj.isMouseDown) {
            obj.isMouseDown = false;
            if (obj.imageBackground.visible) {
                pubSub_sidecar_1.pubSub.emit('gui:click-button');
                obj.onClick();
            }
        }
        if (obj.isMouseRightDown) {
            obj.isMouseRightDown = false;
        }
    });
    return obj;
}
exports.create = create;
// export function setImages(
//   obj: IButton2,
//   normal: ISPD,
//   highlighted: ISPD,
//   selected: ISPD,
// ) {
//   obj.frames = [normal, highlighted, selected]
// }
function setLocked(obj) {
    // setIcon(obj, sprites.underUiLock[0])
}
exports.setLocked = setLocked;
function setTag(obj, tag) {
    obj.tag = tag;
}
exports.setTag = setTag;
function setIcon(obj, sprite, scale, ox, oy) {
    if (scale === void 0) { scale = 4; }
    if (ox === void 0) { ox = -68; }
    if (oy === void 0) { oy = 4; }
    if (!obj.imageIcon) {
        obj.imageIcon = spritesUtil_sidecar_1.spritesUtil.createImage(obj.imageBackground.parentContainer, sprite);
    }
    spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageIcon, sprite);
    obj.imageIcon.scale = scale;
    obj.iconOx = ox;
    obj.iconOy = oy;
    moveTo(obj, obj.x, obj.y);
}
exports.setIcon = setIcon;
function setAdditionalHighlightAndSelectedImages(obj, highlighted, selected) {
    obj.frames2 = [highlighted, selected];
}
exports.setAdditionalHighlightAndSelectedImages = setAdditionalHighlightAndSelectedImages;
function setScale(obj, scale) {
    obj.scale = scale;
    obj.imageBackground.scale = scale * 4;
    stevieTexts2_sidecar_1.stevieTexts2.setScale(obj.text, scale);
    moveTo(obj, obj.imageBackground.x, obj.imageBackground.y);
}
exports.setScale = setScale;
function setSelected(obj, isSelected) {
    obj.isSelected = isSelected;
}
exports.setSelected = setSelected;
function setText(obj, text) {
    stevieTexts2_sidecar_1.stevieTexts2.setText(obj.text, text);
}
exports.setText = setText;
function setTextTint(obj, tint) {
    stevieTexts2_sidecar_1.stevieTexts2.setTint(obj.text, tint);
}
exports.setTextTint = setTextTint;
function setVisible(obj, visible) {
    obj.imageBackground.visible = visible;
    stevieTexts2_sidecar_1.stevieTexts2.setVisible(obj.text, visible);
}
exports.setVisible = setVisible;
function setOnClick(obj, onClick) {
    obj.onClick = onClick;
}
exports.setOnClick = setOnClick;
function setOnMouseOver(obj, onMouseOver) {
    obj.onMouseOver = onMouseOver;
}
exports.setOnMouseOver = setOnMouseOver;
function setOnMouseOut(obj, onMouseOut) {
    obj.onMouseOut = onMouseOut;
}
exports.setOnMouseOut = setOnMouseOut;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killBulk(objs) {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    return [];
}
exports.killBulk = killBulk;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.imageBackground.destroy();
        stevieTexts2_sidecar_1.stevieTexts2.kill(c.text);
        if (c.imageIcon) {
            c.imageIcon.destroy();
        }
    });
}
exports.updateAll = updateAll;
function update(obj) {
    var frameIdx = 0;
    if (obj.isMouseDown) {
        frameIdx = 2;
    }
    else if (obj.isOver) {
        frameIdx = 1;
    }
    else {
        frameIdx = 0;
    }
    if (obj.isSelected) {
        frameIdx += 3;
    }
    spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageBackground, obj.frames[frameIdx % obj.frames.length] ||
        defaultFrames[frameIdx % defaultFrames.length]);
    if (obj.frames2 && obj.frames2.length > 0) {
        if (obj.isMouseDown || obj.isSelected) {
            frameIdx = 1;
        }
        else if (obj.isOver) {
            frameIdx = 0;
        }
        else {
            frameIdx = -1;
        }
        if (frameIdx !== -1) {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrame(obj.imageAdditional, obj.frames2[frameIdx]);
            obj.imageAdditional.visible = true;
        }
        else {
            obj.imageAdditional.visible = false;
        }
    }
}
exports.update = update;
function moveTo(obj, x, y) {
    obj.x = x;
    obj.y = y;
    obj.imageBackground.x = x;
    obj.imageBackground.y = y;
    obj.imageAdditional.x = x;
    obj.imageAdditional.y = y;
    if (obj.imageIcon) {
        obj.imageIcon.x = x + obj.iconOx;
        obj.imageIcon.y = y + obj.iconOy;
    }
    stevieTexts2_sidecar_1.stevieTexts2.moveTo(obj.text, x - obj.imageBackground.width / 2 + obj.textOx, y + obj.textOy);
}
exports.moveTo = moveTo;
function setTextOffset(obj, x, y) {
    obj.textOx = x;
    obj.textOy = y;
    moveTo(obj, obj.x, obj.y);
}
exports.setTextOffset = setTextOffset;
function setTextScale(obj, s) {
    stevieTexts2_sidecar_1.stevieTexts2.setScale(obj.text, s);
}
exports.setTextScale = setTextScale;
function setBulkVisible(objs, isVisible) {
    imports_1.l.forEach(objs, function (c) { return setVisible(c, isVisible); });
}
exports.setBulkVisible = setBulkVisible;
var highlight = function (obj) {
    obj.isSelected = true;
};
exports.highlight = highlight;
var unhighlight = function (obj) {
    obj.isSelected = false;
};
exports.unhighlight = unhighlight;
var executeClick = function (obj) {
    obj.onClick();
};
exports.executeClick = executeClick;
